import userUtil from 'utils/miscellaneous/user/user_util';

// Schedule-FE records the requester RN of whoever deactivated a shift. Admins (RN:USER-V1-), caregivers
// (RN:CAREGIVER-V1-) and client contacts (RN:CLIENT-V1-...:RELATIONSHIP-V1-...) are all Identity-FE users so their
// name can be resolved. Internal services (RN:SERVER-V1-SLACK, RN:SERVER-V1-WORKFLOWENGINE, ...) are not.
// Matched on the resource name alone because server RNs are written with both separators (RN:SERVER-V1-SLACK and
// RN:SERVER_V1_IDENTITY both occur).
const SERVER_RN_PREFIX = 'RN:SERVER';

const isServerRn = (value) => {
  return typeof value === 'string' && value.startsWith(SERVER_RN_PREFIX);
};

const isResolvableActorRn = (value) => {
  return typeof value === 'string' && value.startsWith('RN:') && !isServerRn(value);
};

const getChangedByActor = (changedByRn) => {
  if (!changedByRn) {
    return null;
  }

  return isServerRn(changedByRn) ? 'SERVER' : 'USER';
};

// Falls back to null so callers can show the raw RN instead of a half-resolved name.
const formatChangedByLabel = (userData) => {
  const displayName = userUtil.getFullName(userData?.firstName, userData?.lastName).trim();

  return displayName || null;
};

export {
  isResolvableActorRn,
  getChangedByActor,
  formatChangedByLabel,
};
